import { useSelector } from "react-redux";
import styles from "./index.module.scss";
import Map from "../../pages/shops/map";

export default function Scheme() {
  const { data: shopIndex } = useSelector((state) => state.popup);
  const { shops = [] } = useSelector((state) => state.contacts);
  const shop = shops[shopIndex];

  return (
    <div className={styles.Wrapper}>
      <div>
        <h2>{shop?.name}</h2>
        <Map shop={shop} />
      </div>
    </div>
  );
}
